const PathSubHeader = () => {
  return null;
};

export default PathSubHeader;
